import { AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { CustomEventNewCardEnt } from '../../interfaces/custom-event-new-card-ent';

@Component({
  selector: 'app-custom-full-size-events-news',
  templateUrl: './custom-full-size-events-news.html'
})
export class CustomFullSizeEventsNewsComponent implements AfterViewInit, OnChanges {
  @Input() eventnew : CustomEventNewCardEnt  = new CustomEventNewCardEnt;
  @ViewChild('eventContent') eventContent!: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.eventContent.nativeElement.innerHTML = this.eventnew.content!;
  }

  ngOnChanges() {
    this.eventContent.nativeElement.innerHTML = this.eventnew.content!;
  }
}
